import { logError } from '../../sentry';
const axios = require('axios');
const config = require('../../../../config');
const { timeout } = config.get('apiGateway');
const ServiceResponse = require('../../../models/ServiceResponse');

/**
 * Retrieve all the flags by the current bridge of the platform
 * @param {Number} page
 * @param id string
 * @param countryId
 * @param latitude
 * @param longitude
 * @param landingType
 * @param userId
 * @param filters
 * @param headers
 * @returns {Array} object
 *
 */

const fetchVendorsQC = async (
  page,
  id,
  countryId,
  latitude,
  longitude,
  landingType,
  userId,
  filters,
  headers,
) => {
  try {
    const size = 20;
    const url = `/generic-landings/api/v1/landings/${id}/qc-vendor-items/search?landing_type=${landingType}&page=${page}&size=${size}`;

    const body = {
      user_id: userId,
      location: {
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
      },
      country_id: countryId,
      filter_list: filters,
    };
    const { data } = await axios.post(url, body, {
      timeout,
      headers,
    });

    const { pagination, vendors } = data;
    if (pagination?.total === 0 || vendors?.length === 0) {
      return new ServiceResponse({ error: 404, message: 'NOT_FOUND' });
    }

    return new ServiceResponse({ data });
  } catch (error) {
    logError('[BFF][FETCH_VENDORS_QC]', error);
    if (error?.response?.status) {
      return new ServiceResponse({ error: error.response.status });
    }
    return new ServiceResponse({ error });
  }
};

export default fetchVendorsQC;
